'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const Languages = {
    'en-US': 'us',
    'fr-FR': 'fr',
    'es-ES': 'es',
    'it-IT': 'it',
    'de-DE': 'de',
    'ru-RU': 'ru',
    'nl-NL': 'nl',
    'pt-BR': 'br',
    'zh-CN': 'cn',
    'he-IL': 'il',
    'cs-CZ': 'cz',
    'ko-KR': 'kr',
    'ja-JP': 'jp',
    'zh-TW': 'tw',
    'bg-BG': 'bg',
    'hr-HR': 'hr',
    'da-DK': 'dk',
    'fi-FI': 'fi',
    'el-GR': 'gr',
    'hu-HU': 'hu',
    'nb-NO': 'no',
    'pl-PL': 'pl',
    'pt-PT': 'pt',
    'ro-RO': 'ro',
    'sv-SE': 'se',
    'tr-TR': 'tr',
    sk: 'sk',
    sl: 'sl',
    'et-EE': 'ee',
    'id-ID': 'id',
    ar: 'ar',
    lt: 'lt',
    'lv-LV': 'lv',
    'th-TH': 'th',
};
function isLanguageCode(lang) {
    return !!Object.keys(Languages).includes(lang);
}

exports.Languages = Languages;
exports.isLanguageCode = isLanguageCode;
//# sourceMappingURL=multilingual.js.map
